module.exports = __webpack_public_path__ + "static/media/cctv@2x.47aa984a.png";